import { apiClient } from './client';
import { UserDropdownDto } from '../types';
import { useQuery } from '@tanstack/react-query';

export const usersApi = {
  list(brgId?: number, active: boolean = true): Promise<UserDropdownDto[]> {
    const params = new URLSearchParams();
    params.set('active', String(active));
    if (brgId) params.set('brgId', String(brgId));
    return apiClient.get<UserDropdownDto[]>(`/api/users?${params.toString()}`);
  },

  search(query: string, activeOnly = true): Promise<UserDropdownDto[]> {
    const qs = new URLSearchParams();
    qs.set('search', query);
    if (activeOnly) qs.set('active', 'true');
    return apiClient.get<UserDropdownDto[]>(`/api/users?${qs.toString()}`);
  },
  
  // Get the current user's assigned BRGs (for Lead access control)
  // TODO: Backend endpoint needed - GET /api/users/me/assigned-brgs
  // Should return: { brgIds: number[] }
  getAssignedBRGs(): Promise<{ brgIds: number[] }> {
    return apiClient.get<{ brgIds: number[] }>(`/api/users/me/assigned-brgs`);
  },
};

/**
 * Hook to fetch the current user's assigned BRGs
 * Used for Lead access control - restricts project creation to assigned BRGs only
 */
export const useUserAssignedBRGs = () => {
  return useQuery({
    queryKey: ['userAssignedBRGs'],
    queryFn: () => usersApi.getAssignedBRGs(),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};
